import { useState } from "react";
import { useReveal, useCountUp } from "../hooks";
import { HeatPump } from "./HeatPump";

const CHECKS = [
  "Thermo pumps & heat pumps sold door-to-door across Quebec",
  "Home energy upgrades with government subsidy guidance",
  "Certified reps trained on efficiency audits and financing options",
];

export const Energy = () => {
  const [ref, inView] = useReveal(0.2);
  const [power, setPower] = useState(true);
  const [mode, setMode] = useState("heat");
  return (
    <section className="sec energy" id="energy" data-testid="energy-section" ref={ref}>
      <div className="container">
        <div className="energy-split">
          <div className={`reveal ${inView ? "in" : ""}`}>
            <span className="eyebrow green">Swift Energy — HVAC Division</span>
            <h2 className="h-display">The same sales machine, now heating <em>Quebec homes</em></h2>
            <p className="lead">
              Our newest division brings Swift's proven face-to-face engine to the
              energy-efficiency market: thermo pumps, heat pumps, and home energy
              upgrades that cut heating costs for Quebec homeowners.
            </p>
            <ul className="energy-checks">
              {CHECKS.map((c, i) => (
                <li key={i}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5" /></svg>
                  {c}
                </li>
              ))}
            </ul>
            <div>
              <HeatPump power={power} mode={mode} speed={1} width={340} />
              <div className="hp-controls">
                <button className={`hp-btn ${power ? "active" : ""}`} onClick={() => setPower(!power)} data-testid="hp-power-btn">
                  {power ? "● Running" : "○ Off"}
                </button>
                <button className={`hp-btn heat ${mode === "heat" && power ? "active" : ""}`} onClick={() => { setMode("heat"); setPower(true); }} data-testid="hp-heat-btn">Heat</button>
                <button className={`hp-btn cool ${mode === "cool" && power ? "active" : ""}`} onClick={() => { setMode("cool"); setPower(true); }} data-testid="hp-cool-btn">Cool</button>
              </div>
            </div>
          </div>
          <div className={`reveal d2 ${inView ? "in" : ""}`}>
            <div className="energy-photo">
              <img src="/assets/hvac-consultation.png" alt="Swift Energy consultant reviewing heat pump options with a client" loading="lazy" />
              <div className="badge">FREE CONSULTATION · QUÉBEC, CA</div>
            </div>
          </div>
        </div>
        <SavingsMeter />
      </div>
    </section>
  );
};

const SavingsMeter = () => {
  const [ref, inView] = useReveal(0.4);
  const pct = useCountUp(40, inView, 1800);
  return (
    <div className="meter-card" ref={ref} data-testid="savings-meter">
      <div className="meter-head">
        <div>
          <span className="eyebrow green" style={{ marginBottom: 8 }}>Average impact</span>
          <h3 className="h-display" style={{ fontSize: "1.5rem", margin: 0 }}>Annual heating costs, before &amp; after</h3>
        </div>
        <div className="meter-big" data-testid="savings-percentage">−{pct}%</div>
      </div>
      <div className="meter-bars">
        <div className="meter-row">
          <span className="tag">Before</span>
          <div className="meter-track"><div className="meter-fill before" style={{ width: inView ? "100%" : 0 }} /></div>
          <span className="amt">$3,200</span>
        </div>
        <div className="meter-row">
          <span className="tag">After</span>
          <div className="meter-track"><div className="meter-fill after" style={{ width: inView ? "60%" : 0 }} /></div>
          <span className="amt" style={{ color: "var(--green)" }}>$1,920</span>
        </div>
      </div>
    </div>
  );
};
